import React from "react";

const AdressIcon = () => (
  <svg
    width="32"
    height="26"
    viewBox="0 0 32 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.329558 11.9236L15.803 0.64363C15.9204 0.558041 16.0796 0.558041 16.197 0.64363L31.6704 11.9236C31.932 12.1143 31.7971 12.5283 31.4734 12.5283H28.7095C28.5247 12.5283 28.375 12.678 28.375 12.8628V25.6655C28.375 25.8503 28.2253 26 28.0405 26H18.397C18.2122 26 18.0625 25.8503 18.0625 25.6655V16.6835C18.0625 16.4988 17.9128 16.3491 17.728 16.3491H14.272C14.0872 16.3491 13.9375 16.4988 13.9375 16.6835V25.6655C13.9375 25.8503 13.7878 26 13.603 26H3.95947C3.77474 26 3.625 25.8503 3.625 25.6655V12.8628C3.625 12.678 3.47525 12.5283 3.29053 12.5283H0.526585C0.202853 12.5283 0.0679574 12.1143 0.329558 11.9236Z"
      fill="#30323A"
    />
  </svg>
);

export default AdressIcon;
